'use client'

import PropTypes from 'prop-types'
import { WizardPanel } from '@repo/ui/WizardPanel'
import { WizardFormSection } from '@repo/ui/WizardFormSection'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'
import { LargeCashIcon } from '@repo/ui/LargeCashIcon'
import MUIStack from '@mui/material/Stack'
import { TextEntry } from '@repo/ui/TextEntry'
import { useRef, useState } from 'react'
import { validate } from '@repo/validation/validation'
import { accountControlSchema } from '@repo/validation/schema_NewMatter'
import { useToastStore } from '@repo/store/useToastStore'

export const NewMatterAccountControlDetails = ({ updateStepState, wideMode, handlePrevNext }) => {
  const { debtorLimit, wipLimit, disbursementsLimit, updateState } = useNewMatterStore()
  const formRef = useRef()
  const [validationErrors, setValidationErrors] = useState({})
  const { showToast } = useToastStore()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setValidationErrors({})

    const stateToSave = {
      debtorLimit,
      wipLimit,
      disbursementsLimit
    }

    try {
      await validate(accountControlSchema, stateToSave)
    } catch (err) {
      const { inner } = err
      const errors = {}
      let firstErrorKey
      inner.forEach(({ path, message }, index) => {
        errors[path] = message
        if (index === 0) firstErrorKey = CSS.escape(path)
      })

      console.log(errors)

      showToast({ type: 'error', text: 'Please check all fields for errors', title: 'Form errors' })

      // scroll to error if possible
      const container = document.querySelector('[data-testid="WizardStepContentsContainer"]')
      const errorElement = firstErrorKey
        ? document.querySelector(`[data-testid="WizardPanel"]:has([name=${firstErrorKey}])`)
        : null
      if (container && errorElement) container.scrollTop = errorElement.offsetParent?.offsetTop || 0

      setValidationErrors(errors)
      return
    }

    updateStepState({ status: 'completed', statusText: 'Complete' })
    handlePrevNext(1)
  }

  const handleClickBack = () => {
    handlePrevNext(-1)
  }

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <WizardPanel data-testid="NewMatterAccountControlDetails">
        <WizardFormSection>
          <WizardIconTitle title="Debt warnings" icon={LargeCashIcon} sx={{ mb: 8 }} isOptional />

          <MUIStack gap={4} direction="row" alignItems="center" flexWrap={'wrap'} sx={{ width: '100%' }}>
            <TextEntry
              value={debtorLimit}
              onChange={(value) => updateState({ key: 'debtorLimit', value })}
              isNumber
              label="Debtor limit"
              sx={{ width: '100%', maxWidth: '478px' }}
              adornment="£"
              size="medium"
              autoFocus
              name="debtorLimit"
              errors={validationErrors}
            />

            <TextEntry
              value={wipLimit}
              onChange={(value) => updateState({ key: 'wipLimit', value })}
              isNumber
              label="WIP limit"
              sx={{ width: '100%', maxWidth: '478px' }}
              adornment="£"
              size="medium"
              name="wipLimit"
              errors={validationErrors}
            />

            <TextEntry
              value={disbursementsLimit}
              onChange={(value) => updateState({ key: 'disbursementsLimit', value })}
              isNumber
              label="Disbursements limit"
              sx={{ width: '100%', maxWidth: '478px' }}
              adornment="£"
              size="medium"
              name="disbursementsLimit"
              errors={validationErrors}
            />
          </MUIStack>
        </WizardFormSection>
      </WizardPanel>
      <WizardFooter wideMode={wideMode} continueButtonIsFormSubmitButton handleClickBack={handleClickBack} />
    </form>
  )
}

NewMatterAccountControlDetails.propTypes = {
  updateStepState: PropTypes.func,
  currentStep: PropTypes.object,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
